<template>
  <button class="button" @click="$emit('click')">
    <span class="trash"></span>
  </button>
</template>

<script>
export default {};
</script>

<style scoped>
.button {
  color: white;
  border: none;
  outline: none;
  font-family: "EBI-Common";
  font-size: 20px;
  max-width: 2em;
  padding-bottom: 3px;
  padding: 0px 0px 2px 0px;
  height: 26px;
  width: 26px;
  align-content: center;
}
.trash {
  font-size: 18px;
  align-content: center;
}

.button:hover {
  background: var(--accent);
  outline: none;
}
</style>